import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider, useQueryRequest} from './core/QueryRequestProvider'
import {QueryResponseProvider, useQueryResponse} from './core/QueryResponseProvider'
import {Table} from './Table'
import {KTCard} from '../../../../../_metronic/helpers'
import {Header} from '../../../../../_component/table/Header'
import {deleteJob} from './core/_requests'

const List = () => {
  const {
    selected,
    clearSelected,
  } = useListView()
  const {refetch, isLoading} = useQueryResponse()
  const {updateState} = useQueryRequest()

  return (
    <>
      <KTCard>
        <Header
          updateState={updateState}
          isLoading={isLoading}
          refetch={refetch}
          selected={selected}
          clearSelected={clearSelected}
          deleteAction={deleteJob}
          fields={['status']}
          title='Job'
          customCreatePath='/jobs/new'
          searchAble={true}
          searchFields={['title', 'department', 'location']}
        />
        <Table />
      </KTCard>
    </>
  )
}

export const JobsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <List />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
